"use client";

import React, { Component, FC, ReactNode } from "react";
import Image, { StaticImageData } from "next/image";

export type content_type = 
{
    title?: string,
    content: (string | React.ReactNode)[],
    imageLeft?: StaticImageData
    imageRight?: StaticImageData
    image_alt_text?: string
};

const renderPara = (para: string | ReactNode) => (typeof para === "string") ? <p>{para}</p> : para;

const renderText = (item: content_type) => (
    <>
        {item.title && <h3 className="tp-section-title pb-15">{item.title}</h3>}
        {item.content.map((para, index) => (
            <div className="postbox-details__text mb-20" key={index}>
                {renderPara(para)}
            </div>
        ))}
    </>
)

const renderImageLeft = (item: content_type) => {
    return (
        <div className="row">
            <div className="col-xl-4 col-lg-4">
                <div className="postbox-details__thumb-2 pb-55">
                    <Image
                        src={item.imageLeft!}
                        style={{ width: "460px", height: "300px" }}
                        alt={item.image_alt_text!} />
                </div>
            </div>
            <div className="col-xl-8 col-lg-8">
                {item.title && <h3 className="postbox-details__title pb-15">{item.title}</h3>}
                {item.content.map((para,index) => (
                    <div className="postbox-details__text mb-10" key={index}>
                        {renderPara(para)}
                    </div>
                ))}
            </div>
        </div>
    );
}
const renderImageRight = (item: content_type) => {
    return (
       <div className="row">
            <div className="col-xl-8 col-lg-8">
                {item.title && <h3 className="postbox-details__title pb-15">{item.title}</h3>}
                {item.content.map((para,index) => (
                    <div className="postbox-details__text mb-10" key={index}>
                        {renderPara(para)}
                    </div>
                ))}
            </div>
            <div className="col-xl-4 col-lg-4">
                <div className="postbox-details__thumb-2 pb-55">
                    <Image
                        src={item.imageRight!}
                        style={{ width: "460px", height: "300px" }}
                        alt={item.image_alt_text!} />
                </div>
            </div>
        </div>
        
    );
}

type Props = {
    content: content_type[]
}

const ContentBlock: FC<Props> = ({ content }: Props) => {
    return (
        <div className="container">
            <div className="">
                <div className="">
                    <div className="postbox-details__wrapper">
                        {content.map((item,index) => (
                            <div key={index}>
                                {
                                    (item.imageLeft) ? renderImageLeft(item) : 
                                    (item.imageRight) ? renderImageRight(item) : renderText(item)
                                }
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContentBlock;
